module.exports = __webpack_public_path__ + "img/classGroupPic.e7c18180.jpeg";